import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import SideBar from "../../components/Sidebar";
import ProfileService from "../../services/ProfileService";
import PGService from "../../services/PGService";
import AddMoneyModal from "./AddMoneyModal";
import { FaWallet } from "react-icons/fa";

const Wallet = () => {
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [balanceData, setBalanceData] = useState();

  useEffect(() => {
    fetchData();
    recentTransactions();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await ProfileService.fetchBalance();
      if (!result.success) {
        Swal.fire("Oops!", result.message, "error");
        return;
      }

      const responseData = result.data;
      if (responseData.status === "SUCCESS") {
        setBalanceData(responseData.data);
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        "Request Failed: " + (error.response?.data || error.message),
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const [data, setData] = useState();

  const recentTransactions = async () => {
    setLoading(true);
    try {
      const result = await PGService.recentTransactions();
      if (!result.success) {
        Swal.fire("Oops!", result.message, "error");
        return;
      }

      const responseData = result.data;
      if (responseData.status === "SUCCESS") {
        setData(responseData.data);
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        "Request Failed: " + (error.response?.data || error.message),
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-3">
      <div className="row">
        {/* Sidebar */}
        <SideBar />

        {/* Main Content */}
        <div className="col-md-9">
          {/* Wallet Card */}
          <div className="card mb-3">
            <div className="card-body py-4">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-md-4">
                <div className="text-center mb-3 mb-md-0">
                  <FaWallet size={48} className="text-primary mb-2" />
                  <h6 className="text-muted">Available Balance</h6>
                  <h2 className="text-success fw-bold">
                    ₹{balanceData ? balanceData.main_wallet : "0.00"}
                  </h2>
                </div>
                <div className="text-center">
                  <button
                    className="btn btn-success btn-lg px-4 py-2 rounded-pill shadow"
                    onClick={() => setShowModal(true)}
                  >
                    Add Money
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Features / Tips */}
          <div className="row">
            <div className="col-md-4 mb-3">
              <div className="card h-100 shadow-sm border-0 rounded-3">
                <div className="card-body d-flex flex-column justify-content-center align-items-center text-center py-4">
                  <i className="bi bi-lightning-charge-fill text-warning fs-2 mb-2"></i>
                  <h6 className="fw-semibold mb-1">Instant Topup</h6>
                  <p className="text-muted small mb-0">
                    Funds added instantly to your wallet.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="card h-100 shadow-sm border-0 rounded-3">
                <div className="card-body d-flex flex-column justify-content-center align-items-center text-center py-4">
                  <i className="bi bi-shield-lock-fill text-primary fs-2 mb-2"></i>
                  <h6 className="fw-semibold mb-1">Secure Payments</h6>
                  <p className="text-muted small mb-0">
                    100% safe and secure transactions.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="card h-100 shadow-sm border-0 rounded-3">
                <div className="card-body d-flex flex-column justify-content-center align-items-center text-center py-4">
                  <i className="bi bi-headset text-info fs-2 mb-2"></i>
                  <h6 className="fw-semibold mb-1">24x7 Support</h6>
                  <p className="text-muted small mb-0">
                    We're always here to help you.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Transaction History Placeholder */}
          {/* Transaction History */}
          <div className="card mb-4">
            <div className="card-header bg-white fw-semibold">
              Recent Transactions
            </div>
            <div className="card-body">
              {!loading && data && data.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th>Order ID</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Remark</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((txn, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{txn.order_id}</td>
                          <td>₹{txn.amount}</td>
                          <td>
                            <span
                              className={`badge ${
                                txn.status === "SUCCESS"
                                  ? "bg-success"
                                  : txn.status === "FAILED"
                                  ? "bg-danger"
                                  : txn.status === "PENDING"
                                  ? "bg-warning text-dark"
                                  : "bg-secondary"
                              }`}
                            >
                              {txn.status}
                            </span>
                          </td>
                          <td>{txn.remark || "N/A"}</td>
                          <td>{new Date(txn.created_on).toLocaleString()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-muted">No recent transactions found.</p>
              )}
            </div>
          </div>

          {loading && (
            <div className="text-center mt-4">
              <div className="spinner-border text-primary" role="status" />
            </div>
          )}
        </div>
      </div>

      {/* Add Money Modal */}
      <AddMoneyModal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        balanceData={balanceData}
        fetchBalance={fetchData}
      />
    </div>
  );
};

export default Wallet;
